import { Routes } from '@angular/router';
import { HuntPackageTrialResolver } from '../shared/components/hunt-package/hunt-package.resolver';
import { DashboardComponent } from './components/filter/components/dashboard/dashboard.component';
import { FilterComponent } from './components/filter/filter.component';
import { SearchComponent } from './components/filter/search/search.component';
import { DrillDownHuntPackageComponent } from './components/hunt-package/hunt-package.component';
import { DrillDownThreatProfileComponent } from './components/threat-profiles/threat-profiles.component';
import { ResearchComponent } from './research.component';

export const ResearchRoutes: Routes = [
  {
    path: '',
    component: ResearchComponent,
    children: [
      {
        path: '',
        component: FilterComponent,
        children: [
          { path: '', component: DashboardComponent },
          { path: 'search', component: SearchComponent },
        ],
      },
      {
        path: 'hunt-package/:hunt_package_uuid',
        component: DrillDownHuntPackageComponent,
        resolve: {
          huntPackage: HuntPackageTrialResolver,
        },
      },
      {
        path: 'threat-profile/:uuid',
        component: DrillDownThreatProfileComponent,
      },
    ],
  },
];
